// ReviewViewDialog.tsx

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  Box,
  Rating,
} from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid';

interface ReviewData {
  comment?: string;
  rating?: number | string;
}

interface ReviewViewDialogProps {
  currentReview: ReviewData | null;
  onClose: () => void;
}

const ReviewViewDialog: React.FC<ReviewViewDialogProps> = ({
  currentReview,
  onClose,
}) => {
  return (
    <Dialog open={!!currentReview} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        View Review
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <GridCloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', mt: 3, gap: 2 }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            fontWeight="bold"
            mb={1}
          >
            Comment:
          </Typography>
          <Typography variant="subtitle1" gutterBottom mb={1}>
            {currentReview?.comment || '-'}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', mt: 3, gap: 2 }}>
          <Typography
            variant="subtitle1"
            gutterBottom
            fontWeight="bold"
            mb={1}
          >
            Rating:
          </Typography>
          <Rating
            value={Number(currentReview?.rating) || 0}
            readOnly
            precision={0.5}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReviewViewDialog;
